<template>
  <div>
    <v-tooltip
      top
      dark
    >
      <template v-slot:activator="{ on }">
        <v-chip
          class="user-chip"
          color="primary"
          text-color="white"
          selected
          @click="onClick"
          v-on="on"
        >
          <v-avatar>
            <v-icon>donut_small</v-icon>
          </v-avatar>
          <v-progress-circular
            v-if="loading"
            :size="15"
            color="white"
            indeterminate
          />
          <span v-else>
            {{ trancheName }}
          </span>
          <v-icon
            class="ml-3"
            small
            @click.stop.prevent="copyId"
          >
            content_copy
          </v-icon>
        </v-chip>
      </template>
      Open or Copy Tranche
    </v-tooltip>
    <v-snackbar
      v-model="snackbar"
      bottom="bottom"
      :timeout="timeout"
      color="blue-grey"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import { toQueryString } from '@/helpers';

export default {
  name: 'TrancheChip',
  props: {
    id: {
      type: String,
      default: null,
      required: true,
    },
    tranche: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentTranche: null,
      loading: false,
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
    };
  },
  computed: {
    trancheName() {
      if (this.tranche) {
        return this.tranche.project_name;
      }

      if (this.currentTranche) {
        return this.currentTranche.project_name;
      }

      return '';
    },
    trancheId() {
      if (this.tranche) {
        return this.tranche.id;
      }

      if (this.currentTranche) {
        return this.currentTranche.id;
      }

      return '';
    },
  },
  mounted() {
    if (this.tranche) {
      return;
    }

    this.fetchTranche();
  },
  methods: {
    ...mapActions([
      'getFinancialProduct',
    ]),

    async fetchTranche() {
      this.loading = true;

      try {
        this.currentTranche = (await this.getFinancialProduct(toQueryString({
          id: this.id,
        }))).tranche;
        this.loading = false;
      } catch (error) {
        this.currentTranche = null;
        this.loading = false;
      }
    },
    onClick() {
      const timestamp = new Date(this.currentTranche.created_at).getTime();
      this.$router.push(
        `/financial-products/tranche/
        ${this.currentTranche.instrument}/
        ${this.currentTranche.security_id_type}/
        ${this.currentTranche.security_id}/${timestamp}`,
      );
    },
    async copyId() {
      await navigator.clipboard.writeText(this.id);
      this.snackbarText = `ID "${this.id}" copied to clipboard.`;
      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-chip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/financialProduct/TrancheChip.vue